import { render } from "./PlanSuccessReload.vue?vue&type=template&id=0666fe57"
import script from "./PlanSuccessReload.vue?vue&type=script&lang=js"
export * from "./PlanSuccessReload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__